import { useCommonStore } from '~~/store/common';
import { useParamsStore } from '~~/store/local-storage/params';

export default defineNuxtRouteMiddleware(async (to) => {
  console.log('CheckRequireParams');
  const { $cloudCommonApi, $decodeJwt, $ENV_NAME, $getEnvName, $CLOUD_COMMON_URL, $SYSTEM_ROLE } =
    useNuxtApp();

  let isError = false;

  if (to.fullPath.includes('error')) {
    return;
  }
  // エラー処理作成
  const fetchError = async function (statusCode: number) {
    const common = useCommonStore();
    await common.fetchError(statusCode);
  };

  const params = useParamsStore();
  let idToken = null;
  let projectId = null;
  let userId = null;

  // 権限チェック
  let roleError = false;
  switch (params.systemRole) {
    case $SYSTEM_ROLE.SUBJECT_MANAGER:
    case $SYSTEM_ROLE.USER:
      if (to.path.startsWith('/control-groups')) {
        roleError = true;
      }
      if (to.path.startsWith('/system-setting/')) {
        roleError = true;
      }
  }
  if (roleError) {
    // 権限エラーとする
    const common = useCommonStore();
    await common.fetchError(403);
    return;
  }

  // URLからトークン、件名IDを取得
  if (to.query.id_token) {
    idToken = to.query.id_token;
    try {
      userId = $decodeJwt(idToken.toString()).sub;
    } catch (e) {}
  }
  if (to.query.p_id) projectId = ('00000' + to.query.p_id).slice(-5);

  // パラメータチェック
  if (
    (idToken == null || projectId == null || Number(projectId) > 99999 || Number(projectId) < 1) &&
    !isError
  ) {
    const localStorageParamsStr = localStorage.getItem('params');
    if (!localStorageParamsStr) {
      if (process.env.NODE_ENV === 'development') {
        const config = useRuntimeConfig();
        idToken = 'dummy';
        userId = config.public.appUserId;
        projectId = config.public.appProjectId;
        console.log(
          `dummy userId:${config.public.appUserId}, projectId:${config.public.appProjectId}`
        );
      } else {
        isError = true;
      }
    } else {
      try {
        const localStorageParams = JSON.parse(localStorageParamsStr);
        if (!localStorageParams) {
          isError = true;
        } else {
          idToken = localStorageParams.idToken;
          userId = localStorageParams.userId;
          projectId = localStorageParams.projectId;
        }
      } catch (e) {
        isError = true;
      }
    }
  }

  if (
    idToken == null ||
    idToken == '' ||
    projectId == null ||
    projectId == '' ||
    userId == null ||
    userId == '' ||
    isError
  ) {
    // 共通基盤ログイン画面へ遷移
    const tmpEnvName = $getEnvName();
    let envName = '';
    if (tmpEnvName !== $ENV_NAME.PROD) envName = tmpEnvName + '-';
    window.location.href = $CLOUD_COMMON_URL.LOGIN.replace('{envName}', envName);
  }
  // ローカルストレージに値を設定
  params.setIdToken(idToken);
  params.setProjectId(projectId);
  params.setUserId(userId);

  // ユーザー詳細情報取得
  const userDetailResponse = await $cloudCommonApi.getUser(projectId, userId, fetchError);

  if (!userDetailResponse) {
    return await fetchError(500);
  }
  if (userDetailResponse.status != 200) {
    //200以外の場合
    return await fetchError(userDetailResponse.status);
  }

  // 件名情報取得
  const projectDetailResponse = await $cloudCommonApi.getProject(projectId, fetchError);

  if (!projectDetailResponse) {
    return await fetchError(500);
  }
  if (projectDetailResponse.status != 200) {
    //200以外の場合
    return await fetchError(projectDetailResponse.status);
  }
  // ローカルストレージに各APIから取得した値を設定
  params.setSystemRole(userDetailResponse.body.systemRole);
  params.setCustomerProjectName(projectDetailResponse.body.customerProjectName);
});
